import { HeroBackground, ProductMain } from '@prishapolicy/shared/ui';
import {
  CoverageExclusions,
  CoverageFirstTabData,
  ExcludedTabData,
  Faq,
  HeroTicker,
  ProductCategoryPageProps,
  ProfessionalIndemnityFaqList,
  WhyChooseUs,
  getPurchaseFlowHeroForms,
  productsPathAdder,
  useW3PurchaseFlow,
} from '@prishapolicy/w3/ui';
import { NextSeo } from 'next-seo';
import Image from 'next/image';
import React from 'react';
const productCategorySlug = 'professional-indemnity';
import DoctorImage from './doctor.png';
import illustrationImage1 from './illustrationRight.png';
import illustrationImage2 from './illustrationLeft.png';
import ArrowRightLineIcon from 'remixicon-react/ArrowRightSLineIcon';
import Link from 'next/link';

export function ProfessionalIndemnity(props: ProductCategoryPageProps) {
  const { FormRenderer } = useW3PurchaseFlow(props);
  return (
    <div>
      <NextSeo
        title="Liability Insurance | PrishaPolicy"
        description="Liability Insurance : Protect your business from financial losses and legal liabilities with our comprehensive liability insurance coverage"
      />
      <ProductMain color="yellow">
        <HeroBackground backgroundColor="yellow-400" PurchaseFlowFormRenderer={FormRenderer}>
          <div className="grid-cols-2 lg:grid ">
            <div className="flex flex-col justify-between">
              <div className="mb-3">
                <h1 className="heading-1 pb-3">
                  Professional Indemnity
                  <br />
                  For Doctors
                </h1>
                <p className="text-title-6 mb-5 max-w-[600px]">
                  Be a part of one of the largest doctor’s community trusted by 12+ medical associations.
                </p>
                {/* <CalendlyButton /> */}
              </div>
            </div>
            <div className="hidden w-full items-end justify-center lg:flex">
              <div className="lg:w-3/4">
                <Image src={DoctorImage} alt="doctor" />
              </div>
            </div>
          </div>
        </HeroBackground>
        <HeroTicker />
        <div className=" flex flex-col ">
          <div className="container flex flex-col gap-4">
            <h1 className="text-body-1 flex font-medium">
              <Link href="/products/liability-insurance">Liability Insurance</Link>
              <span className="px-2">
                <ArrowRightLineIcon />
              </span>
              Professional Indemnity for Doctors
            </h1>
            <div className="flex flex-col gap-11">
              <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                <div className="flex flex-col justify-center gap-4">
                  <h1 className="text-title-4 lg:text-title-3  font-bold">What is Professional Indemnity?</h1>
                  <p className="text-title-7  prose font-normal">
                    Imagine a safety net that catches doctors if they ever stumble. That’s what professional indemnity
                    insurance is—a special kind of protection that helps doctors if someone says they made a mistake.
                    Covering any money needed for legal and reputational losses to make sure doctors can keep doing
                    their amazing work without worry.
                  </p>
                </div>
                <div>
                  <Image src={illustrationImage1} alt="life insurance" width={520} height={358} />
                </div>
              </div>
              <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
                <div className="order-2 lg:order-1">
                  <Image src={illustrationImage2} alt="life insurance" width={520} height={358} />
                </div>
                <div className="order-1 flex flex-col justify-center gap-4 lg:order-2">
                  <h1 className="text-title-4 lg:text-title-3  font-bold">
                    Why Professional Indemnity is so important for doctors nowadays?
                  </h1>
                  <p className="text-title-7  prose font-normal">
                    Professional indemnity insurance is crucial for doctors to shield against malpractice claims. It
                    ensures that the complexities of healthcare and legal changes don’t jeopardize their career or
                    finances. This insurance is key to managing risks, offering peace of mind to focus on patient care.
                    It not only defends against financial liabilities but also protects doctors’ reputations, allowing
                    them to practice confidently and securely.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <CoverageExclusions
            title={'Coverages and Exclusions'}
            description={' Check out what’s covered and what’s not. It’s like your guidelines before buying'}
            firstTabValue={'Covered'}
            firstTabData={CoverageFirstTabData}
            secondTabValue={'Excluded'}
            secondTabData={ExcludedTabData}
          />

          <WhyChooseUs />
          <div className="container">
            <Faq list={ProfessionalIndemnityFaqList} />
          </div>
        </div>
      </ProductMain>
    </div>
  );
}

export function getStaticProps() {
  const productPaths = productsPathAdder(productCategorySlug);
  return {
    props: {
      ...getPurchaseFlowHeroForms(productCategorySlug).props,
      productPaths,
    },
  };
}
export default ProfessionalIndemnity;
